import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class ContentRecommendations extends AbstractRequestTask {

    constructor(groupId = {}, quantity = 10, filterlist = "31032,30978", is_only_provider = false, showRecommendations = false) {
        super();
        this.groupId = groupId;
        this.quantity = quantity;
        this.filterlist = filterlist;
        this.is_only_provider = is_only_provider;
        this.showRecommendations = showRecommendations;
    }

    getHeaders() {
        return {};
    }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      return `${http}${url}/services/content/recommendations`;
    }

    getParams() {
        const params = super.getParams();
        const newParams = {
          group_id: this.groupId,
          quantity: this.quantity,
          order_id: "ASC",
          order_way: "ASC",
          filterlist: this.filterlist,
          is_only_provider: this.is_only_provider,
          is_kids: this.showRecommendations ? false : true, // Si showRecommendations es false, se establece is_kids en true para filtrar contenido restringido
        };

        return { ...params, ...newParams };
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}

export default ContentRecommendations;



// WEBPACK FOOTER //
// ./src/requests/tasks/content/ContentRecommendationsTask.js